import styled from '@emotion/styled';

import {
  animation,
  border,
  boxShadow,
  breakpoints,
  colors,
  fontWeight,
} from '@datacamp/waffles-tokens';

/* eslint-disable import/prefer-default-export */

export const BorderedLinks = styled.div`
  display: flex;

  a {
    padding-left: ${props => (props.spacing ? `${props.spacing}px` : '8px')};
    padding-right: ${props => (props.spacing ? `${props.spacing}px` : '8px')};
  }

  a:not(:first-of-type) {
    border-left: 1px solid
      ${props => (props.borderColor ? props.borderColor : colors.greyLighter)};
  }

  a:last-of-type {
    padding-right: 0;
  }
`;

export const Wrapper = styled.div`
  left: -16px;
  opacity: 0;
  position: absolute;
  padding: 32px 16px 16px 16px;
  pointer-events: none;
  right: -16px;
  top: 48px;
  transform: none;
  transition: visibility 0.15s, opacity 0.3s ease, top 0.25s;
  visibility: hidden;
  z-index: 90;

  .trigger:hover & {
    opacity: 1;
    pointer-events: auto;
    top: 36px;
    visibility: visible;
  }
`;

export const Container = styled.nav`
  background: ${colors.white};
  border-radius: ${border.radius};
  box-shadow: ${boxShadow.xxl};
  text-align: left;
  white-space: nowrap;
`;

export const CustomIcon = styled.img`
  margin-right: 8px;
`;

export const DarkLink = styled.a`
  align-items: center;
  color: ${colors.greyDark};
  display: flex;
  margin-top: ${props => (props.mt ? `${props.mt}px` : 0)};
  transition: color ${animation.transition};

  .icon {
    color: ${waffles =>
      waffles.theme.colors
        .primary}; /* Workaround for the Waffles icon component proptype */
    margin-right: 8px;
  }

  &:active,
  &:focus,
  &:hover {
    border-color: transparent;
  }
`;

export const Flex = styled.div`
  display: flex;
`;

export const Child = styled.div`
  flex-grow: 1;
  padding: 24px;

  &:not(:first-of-type) {
    border-left: 1px solid ${colors.greyLighter};
  }
`;

export const Footer = styled.footer`
  background: ${colors.primaryLightest};
  border-radius: 0 0 ${border.radius} ${border.radius};
  display: flex;
  justify-content: flex-end;
  padding: 16px;
`;

export const HideAtLg = styled.div`
  display: block;

  @media screen and (min-width: ${breakpoints.lg}) {
    display: none;
  }
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const ListItem = styled.li`
  &:not(:first-of-type) {
    border-top: 1px solid ${colors.greyLighter};
  }
`;

export const ListLink = styled.a`
  color: ${colors.grey};
  display: flex;
  font-weight: ${fontWeight.regular};
  justify-content: space-between;
  padding: 8px 4px;
  transition: background-color ${animation.transition},
    color ${animation.transition};

  &:active,
  &:focus,
  &:hover {
    background-color: ${colors.primaryLightest};
    border-color: transparent;
    color: ${colors.grey};
  }
`;

export const ShowAtLg = styled.div`
  display: none;

  @media screen and (min-width: ${breakpoints.lg}) {
    display: block;
  }
`;

export const Title = styled.h5`
  margin-bottom: 12px;
`;
